import React, { useContext } from 'react';
import {
	FormImageUploaderNewContext,
	IFormImageUploaderNewContext,
	IMaxFileSizeMB,
} from '../../formImageUploaderNewState/formImageUploaderNewContext';
import { openBrowseFile } from 'utils/openBrowseFile';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { Icon, IconName } from 'components/Icon/Icon';
import { NewButton } from 'components/Button/NewButton/NewButton';
import Text from 'components/Text/Text';
import LoaderWithProps from 'components/Loader/LoaderWithProps';
import style from './MediaModal.module.scss';

interface IProps {
	maxFileSizeMB: IMaxFileSizeMB;
	loading: boolean;
}

export const VideoTabPane: React.FC<IProps> = ({ maxFileSizeMB, loading }) => {
	const { pendingVideo, setPendingVideo, changeTypeOfErrorModalWindow, isUploadingVideo } =
		useContext<IFormImageUploaderNewContext>(FormImageUploaderNewContext);

	const handleVideoChange = (files: FileList | null) => {
		const videoFile = files ? files[0] : '';
		if (!videoFile) {
			return;
		} else if (maxFileSizeMB.video && videoFile.size > 1000 * 1000 * maxFileSizeMB.video) {
			changeTypeOfErrorModalWindow('videoFileSizeExceeded');
		} else if (videoFile.type === 'video/mp4') {
			setPendingVideo({ file: videoFile, src: URL.createObjectURL(videoFile) });
		} else {
			changeTypeOfErrorModalWindow('invalidVideoFormat');
		}
	};

	const handleUploadVideo = () => {
		openBrowseFile({
			onChoose: handleVideoChange,
			accept: '.mp4',
		});
	};

	const renderVideo = () => {
		if (loading) {
			return (
				<div className={style.loaderContainer}>
					<LoaderWithProps loaderSize="big" />
				</div>
			);
		}

		if (!pendingVideo.src) {
			return (
				<div className={style.noImageContainer}>
					<svg className={style.noImageIcon}>
						<use xlinkHref={`${breadcrumbs}#videoDefaultAvatar`} />
					</svg>
				</div>
			);
		}

		return <video className={style.videoPreview} src={pendingVideo.src} controls={true} />;
	};

	return (
		<div className={style.tabPaneBody}>
			{renderVideo()}
			{!loading && (
				<div className={style.tabButtons}>
					<div data-test="uploadVideoButton">
						<NewButton
							variant="primary"
							color="purple"
							size="small"
							iconLeft={<Icon name={IconName.upload} />}
							onClick={handleUploadVideo}
							disabled={isUploadingVideo}>
							<Text translationNameSpace="form" translationKey="uploadVideoButton" asFragment={true} />
						</NewButton>
					</div>
				</div>
			)}
		</div>
	);
};
